import React from 'react';
import classnames from 'classnames';

/**
 * Internal dependencies
 */
import { getNameBySite } from './social-list';

export { name } from './related-sdg.json';
export { RelatedSDG as renderer };

export function RelatedSDG({ data, ...rest }) {
  const { attributes } = data;

  const { blockClass, service } = attributes;

  const iconName = getNameBySite(service);

  const iconClasses = classnames(`goal`, iconName);

  return (
    <>
      <div className={blockClass}>
        <i className={iconClasses} />
      </div>
    </>
  );
}
